import { cdn } from "core/cdn"
import { Gender } from "types/entity"

const en = {
  understood: "Understood",
  birthLocation_with_insee_code: "Place / INSEE birth code ",
  birth_lastname: "Last name",
  birth_location: "Birthplace",
  birth_firstname: "First name",
  pseudo_firstname: "Preferred first name",
  pseudo_lastname: "Preferred last name",
  verified_identity: "Identity verified",
  add_pseudo_firstname: "ADD A FIRST NAME",
  add_pseudo_lastname: "ADD A LAST NAME",
  identity_data: "Identity data",
  birth_names: "Full birth name",
  pseudo_names: "Preferred First name/Last name",
  some_information_comes_from:
    "Some information on your profile has been retrieved via your",
  carte_vitale: "carte vitale",
  and_are_not: "and are not",
  modifiable: "modifiable.",
  sex: "Sex:",
  you_can_add: "You can add ",
  a_pseudo_last_name_different: "a different preferred last name",
  a_pseudo_first_name_different: "a different preferred first name",
  of_your_birth_last_name: "of your last name.",
  of_your_birth_first_name: "of your first name.",
  not_informed: "Not filled in",
  not_informed_singular: "Not filled in",
  date_of_birth: "Date of birth",
  code_insee: "INSEE birth code",
  information_from_carte_vitale: "Information retrieved from your Carte Vitale",
  look_and_verify_relatives_info:
    "Verify and complete the identity of your relative.",
  ICanWait: "No, I can wait",
  IWantToLeave: "Yes",
  doctorWillBeHereSoon: "The doctor will be here soon...",
  woudlYouRatherCancel:
    "Are you sure you want to cancel the teleconsultation request and leave the queue ?",
  doctorIsComingInLessThanFiveMinutes:
    "The doctor will arrive in less than five minutes.",
  lessThanFiveMinutes: "less than 5min.",
  youCanJoinCallsRomm:
    "You can now join the calls room and wait for the doctor for a few minutes.",
  joinVirtualRoom: "Join virtual room",
  accessibility_declaration: "Accessibility declaration",
  twoFa_choseMethodForResend:
    "Choose a method to receive the verification code again.",
  twoFa_enterRecievedCode: "Enter the verification code received",
  bySMSAt: "by SMS at",
  byPhoneAt: "by phone at",
  byEmail: "by Email",
  RelativeAddedSuccessfully: "Congratulations, you've added a relative",
  twoFa_enterValideCode: "Enter valide code.",
  twoFa_resendCode: "RESEND CODE",
  twoFa_codeHasBeenResentBy: (transport) =>
    `The code has been sent by ${transport}`,
  sms: "SMS",
  voice: "voice call",
  twoFa_Titre: "Verification code",
  twoFa_invalidCode: "The verification code is incorrect",
  twoFa_activationError:
    "An error occurred while activating 2FA on your account.",
  twoFa_ResendError: "An error occurred while resending the verification code.",
  twoFa_activateTitle:
    "Secure your account by enabling two-factor authentication(2FA)",
  twoFa_activateSubtitle:
    "To log in to your account, in addition to your password, you will receive a 6-digit code.",
  diagnosis_authorization_on_going: "Authorization in progress",
  retry: "Retry",
  relaunchTest: `RELAUNCH THE TEST`,
  iTurnedDevicesOff: "I turned off the tools",
  pharmacistsPlease: "Pharmacists, please:",
  authorizeAccess: `Authorize access to microphone and/or camera then relaunch the test.`,
  disconnectAndReconnect: `Disconnect and reconnect the camera cable then relaunch the test.`,
  ifYouNeedHelp: `If you need help, you can contact support at`,
  diagnosis_information_unknown_error:
    "The microphone and/or camera do not seem to be working. Please approach the kiosk attendant.",
  diagnosis_title_unknown_error: "Technical errors identified",
  diagnosis_contact_support: "Pharmacists, contact support if needed :",
  diagnosis_information_permission_denied:
    "The microphone and/or camera do not seem to be allowed by the browser. Please approach the kiosk attendante.",
  diagnosis_title_permission_denied:
    "The caméra and/or microphone are unauthorized",
  diagnosis_information_waiting_device:
    "You need to authorize the microphone and camera.",
  diagnosis_title_waiting_device: "Authorization request in progress...",
  diagnosis_title_success: "Retrieving video and audio streams",
  majorityRequired: "Legal majority required",
  majorityRequiredInfo:
    "An account Owner must be at least 16 years old at the time of registration.",
  majorityRequiredInfoFirstChunk: "An account Owner must be ",
  majorityRequiredInfoSecondChunk: "at least 16 years old ",
  majorityRequiredInfoLastChunk: "at the time of registration.",
  minAgeMessage: (minAge: number) => `Age must be at least ${minAge} years.`,
  majorityRequiredAddRelative:
    "You can add a minor relative at the time of the teleconsultation.",
  createYourAccountBeforeAdddingChildRelative:
    "If you are consulting for your child, please create your own account first.",
  createChildRelativeAfter:
    "Once your account is created, you can add your child as a relative.",
  addChildRelativeWithYourOwnVitalCard:
    "For a child, The social security number to be provided should be that of the parent to whom the child is linked.",
  fix: "Fix",
  keepThisNumber: "keep This Number",
  generalist: "Generalist Practitioner",
  modifyInformations: "Modify Information",
  uploadDocumentQuestion:
    "Would you like to send medical documents to the doctor? ",
  uploadDocumentTypesHints: "(medical tests, prescription, wound, ...)",
  uploadDocumentAdd: "Import then select documents",
  uploadDocumentSelectOrAdd: "Select documents to send or add a new document",
  uploadDocumentNoDocumentAvailable: "No document available",
  uploadDocumentAddButton: "New document",
  uDocScanQrCode: "Scan the QR Code using ",
  yourPhonesCamera: "your phone",
  thenFollowTheSteop: " and follow the provided steps",
  UDSendMeSMS: "Or receive the link by SMS",
  UDAskSms: "Request a link by SMS, then follow the steps indicated",
  UDGetLinkBySms: "Receive the link by SMS",
  UDCannotScan: "I can't scan the QR code",
  uploadDocumentTypeCrm: "Medical report",
  uploadDocumentTypeOrdo: "Prescription",
  uploadDocumentTypeMT: "Medication / treatment",
  uploadDocumentTypeC: "Certificate",
  uploadDocumentTypeAG: "Biological analysis",
  uploadDocumentTypeCmd: "Adressing medical mail",
  uploadDocumentSuccess:
    "The document has been successfully imported to your profile!",
  uploadDocumentSuccessButton: "Continue",
  uploadDocumentErrorTitle: "Oops...",
  uploadDocumentErrorSubtitle: "An error has occurred!",
  uploadDocumentErrorRetryButton: "Try again",
  uploadDocumentSmsSentNotification: "An SMS has just been sent to you",
  uploadDocumentTooLarge:
    "The document exceeds the maximum size of 10 MB. Retake the photos with fewer pages.",
  uploadPhotoQualityConsent: "By sending this photo, I understand that a poor quality image may prevent the dermatologist from giving an opinion.",
  uploadDocumentSendButton: "Submit documents",
  UploadRecommendedText:
    "In order to renew your prescription, you should submit a photo of your document.",
  photoTransferText: `To analyze the biology results, please submit a photo of the documents.`,
  dermatoModalText: "Dermatological conditions require the submission of clear, good quality photos of the areas to be examined. Do you wish to continue without submitting anything ?",
  UploadPreviewDC:
    "Press the arrows or double-click on the front image to view it larger.",
  UDModalTransmit: "SUBMIT",
  UDModalIgnore: "IGNORE",
  Renewal: "Prescription Renewal",
  genericAPIError: "An error has occurred.",
  relativeConsent: "Adding a relative on MEDADOM requires their consent.",
  noCreditCardAdded: "You have not registered any card.",
  noTLC: "you do not have any teleconsultation.",
  yourCreditCards: "Your cards",
  subtitleCallAcceptedAndSoon: "is in consultation, you are the next patient.",
  waitingDoctor: "Please wait...",
  tagline: "Your health partner",
  relaunchReader: "Please restart the reader or skip to the next step",
  andYour: "And your",
  and: "And",
  stayLogged: "Stay logged",
  owner: "Owner",
  bornThe: "Born on ",
  OtherRelative: "Autre proche",
  chooseThisRelative: "Choose this relative",
  genericErrorPaymentCard:
    "An error occurred while adding your payment method.",
  setupIntentErrorStripe: "Unable to add the card.",
  genericErrorStripe: "An error occurred. Unable to initiate the request..",
  beSureToBeDisconnected: "Are you sure you want to disconnect?",
  finishAndDisconnect: "Finish and disconnect",
  adminLoginSubtitle: "Administrator login<br />If you are a patient, please ask the person in charge of this device",
  launchFullVideoTuto: "Lanch full video tuto",
  launchChapterVideoTuto: "Brow",
  videoManual: "Training videos",
  StartWithTheTerminal: "Use the terminal",
  WorkWithMedadom: "Working with MEDADOM",
  TerminalOperation: "Terminal operation",
  ClientParcours: " Patient path ",
  ToolsUseCase: "Use of tools",
  TheToolsUseCase: "The use of tools",
  UseCases: "Use cases",
  TheUseCases: "Use cases",
  ContraIndications: " Contra-indications ",
  TheContraIndications: " The contra-indications",
  Path: "Journey",
  ClientInscription: "Patient registration",
  HygieneProcedures: "Hygiene procedures",
  TheHygieneProcedure: "The hygiene procedure",
  Duration: "Duration",
  ProceduresAndBestPractices: "Procedures & best practices",
  CheckupSante: "Health check-up",
  MedPayPro: "Med'Pay Pro",
  close: "Close",
  confirmTheSendingOfYourDocuments:
    "Do you confirm sending your documents to the pharmacist ?*",
  myStatistics: "My statistics",
  statistics: "Statistiques",
  statisticsSendWithSuccess: "statistics has been send to your mail",
  statisticsSendWithFailure: "An error occurred try again later",
  myTutorialVideos: "Training videos",
  teleexpertiseCta: "Tele-expertise",
  otherSettingsCta: "Other settings",
  settingsMssCta: "MSS",
  mssSettingsTitle: "Secure health messaging (MSS)",
  mssSettingsToggleLabel: "Receive communications by MSS",
  mssSettingsScope: "These settings are linked to the owner of this kiosk.",
  mssSettingsNeedsRpps: "First enter the owner's RPPS in Tele-expertise, Owner information.",
  ownerInfoTitle: "Owner information",
  ownerInfoRppsLabel: "RPPS:",
  ownerInfoFinessLabel: "FINESS:",
  ownerInfoMssLabel: "MSS address:",
  ownerInfoMssEnterHeading: "Please enter the owner's MSS email address",
  ownerInfoMssRecoveredHeading: "Please confirm the MSS address retrieved with your RPPS",
  ownerInfoMssPlaceholder: "e-mail",
  ownerInfoRppsNotRecognized: "This RPPS number is not recognised. Please check your entry.",
  ownerInfoMissingRpps: "To save this information, please also fill in the owner's RPPS.",
  ownerInfoMissingFiness: "To save this information, please also fill in the billing FINESS.",
  ownerInfoMssNotSaved: "The MSS email address could not be saved. Please try again later.",
  ownerInfoSaved: "Information saved",
  ownerInfoMssInvalidDomainPrefix: "The MSS address must be an email address ending with",
  ownerInfoMssDomain: ".mssante.fr",
  ownerInfoMssDeactivate: "Deactivate",
  ownerInfoMssOptOutTitle: "Stop receiving communications by MSS",
  ownerInfoMssOptOutText:
    "If you refuse MSS communications, you will not receive any information about your telemedicine requests, and may miss important information.",
  ownerInfoMssOptOutReactivateHint: "You can reactivate them at any time from this screen.",
  ownerInfoMssSkipAccept: "Skip this step",
  ownerInfoMssMissingTitle: "You have not entered your MSS address",
  ownerInfoMssMissingText: "Without an MSS address, you will not receive any information about your teleexpertise requests.",
  ownerInfoMssMissingQuestion: "Do you want to enter it now?",
  ownerInfoMssMissingCta: "Enter my MSS",
  ownerInfoMssOptOutNotSaved: "Your choice could not be saved. Please try again later.",
  pharmaSupportIntro: "If you have any questions, you can contact support:",
  pharmaSupportFrom: "From",
  pharmaSupportDays: "Monday to Saturday",
  pharmaSupportHoursPrefix: "from",
  pharmaSupportHours: "9 AM to 7:30 PM",
  pharmaSupportPhonePrefix: "at",
  pharmaSupportPhone: "01 86 65 55 15",
  pharmaSupportEmailPrefix: "at",
  pharmaSupportEmail: "contact@medadom.com",
  modal_pharmaAccount_title: "Professional space",
  companion: "CARE ASSISTANTS",
  select_reason: "Select reason ...",
  select_birth_location: "birth location",
  anamneseReasonQuestion: "What is the reason for your teleconsultation ?",
  anamneseReasonQuestion_relative_male:
    "What is the reason for your relative's teleconsultation ?",
  anamneseReasonQuestion_relative_female:
    "What is the reason for your relative's teleconsultation ?",
  birthCity: "birth location",
  birthCountry: "birth Country",
  birthLocation: "birth location",
  createCardSuccess: "Your card has been added",
  createCardError: "Your card could not be added",
  city: "City",
  covidHTML: `Coronavirus\r\n (Covid 19)`,
  covid: "Coronavirus (Covid 19)",
  allergy: "Allergies",
  burn: "Burn",
  contraception: "Contraception",
  cystitis: "Cystitis",
  jointpain: "Jointpain (knee, wrist)",
  jointpainWithoutParenthesis: "Jointpain",
  diarrhea_or_vomiting: "Diarrhea or vomitting",
  toothpain: "Dental pain",
  back_pain: "Lower back pain",
  rash: "Rash",
  tired: "Exhaustion/anxiety/stress",
  fever: "Fever",
  sexual_infection: "Sexual infection",
  sore_throat: "Sore throat",
  headache: "Headache",
  stomach_ache: "Stomach aches",
  eye_pain: "Red eye and/or pain",
  cancel_warning:
    "If you cancel now, you will lose your spot in the waiting line.",
  sting: "Sting/bite/wound",
  otitis: "Ears/otitis",
  prescription_refill: "Prescription renewal",
  period_pain: "Painful periods",
  lab_results: "Laboratory results",
  cold_and_flu: "Colds and flu-like illness",
  sinus: "Sinus or stuffy nose",
  cough: "Cough",
  otherReason: "Other",
  DMLA: "DMLA",
  DoYouHaveANir: "Do you have a social security number ?",
  IHaveAccount: "I have<b style='font-weight:normal'>account</b>",
  IHaveNoAccount: "I do not have <b style='font-weight:normal'>account</b>",
  IHaveNoEmail: "I certify that I do not have an email adress",
  IHaveNoNir: "I do not have a social security number",
  IHaveNir: "I have a social security number",
  RelativeHasNir: "The relative has a social security number",
  TooManyRequest: "Too many requests. Please try again later",
  WhenWasThelastConsultation:
    "When was your last consultation (physical) with an orthoptist/ophtalmologist ?",
  aPatientLogged: "A patient is currently logged in : ",
  ame: "Aide Médicale d'État",
  c2s: "Couverture Maladie Universelle",
  ald: "Affection Longue Durée",
  indicateYourRights: "Please indicate your French specific coverage :",
  indicateRelativeRights:
    "Please indicate your relative's French specific coverage :",
  rightsAttest:
    "I declare on my honor that I benefit from C2S (CMU or AME) or ALD. Otherwise, I may face legal action.",
  rightsAttestRelative:
    "I declare on my honor that my relative benefits from C2S (CMU or AME) or ALD. Otherwise, I may face legal action.",
  ameModalTitle: "Declaration on Honor",
  fraudIsPunished: "Any health insurance fraud is punished",
  ameModalAccept: "I declare on my honor its validity",
  ameModalCancel: "I do not",
  ameModalCancelRelative: "My relative does not benefit",
  estimatedTime: "Estimated time",
  yourPaymentMethod: "Your payment method",
  whoIs: "Who is ",
  for: "for ",
  you: "you",
  youWillPayOnlyAfterConsultation: "You will pay only after consultation",
  ameRelativeBenefit: "The relative benefits from C2S (ex-CMU), AME, ALD",
  WeAutomaticallyDetectedBenefit:
    "The carte vitale indicates your membership in C2S (ex-CMU), AME, ALD, 100%",
  ameIBenefit: "I benefit from French C2S (ex-CMU), AME, ALD coverage",
  ameModalContent: `<table class="table-modal">
        <tr> 
          <td> 
            <img src="${cdn("icons/carte_vitale_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            <b>If you are eligible for C2S (ex-CMU) or AME or ALD, you are entitled to a fee exemption.</b>
            For this, you must have an up-to-date certificate of your Universal Health Coverage, your State Medical Assistance, or your Long-Term Illness.
          </span>
            </td>
        </tr>
        <tr>
          <td> 
            <img src="${cdn("icons/pharmacien_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            This can be verified by the pharmacist.
            </span>
          <td>
        </tr>
        <tr>
          <td> 
            <img src="${cdn("icons/attestation_honneur_picto.svg")}"> 
          </td>
          <td>
            <span class="modal-content">
            <b>
            I declare on my honor that I meet the conditions stated above for a fee exemption, otherwise I may face legal action.
            </b>
            </span>
          </td>
        </tr>
        <table>`,
  cardRefused: "Card Refused",
  paymentFailed: "Payment Failed",
  useAnotherPaymentMethod: "Please try again or use another payment method.",
  errorPaymentModalTitle:
    "Your payment card has been declined by our payment provider. Please ensure that :",
  errorPaymentModalChangeCard: "Change card",
  errorPaymentModalRetry: "Retry",
  errorPaymentModal_html: `
        <table class="table-modal small">
            <tr>
              <td> 
                <img src="${cdn("icons/picto_paiement.svg")}"> 
              </td>
              <td>
                <span class="modal-content">
                  You have <b>sufficient funds in your bank account.</b>
                </span>
              <td>
            </tr>
            <tr>
            <td> 
              <img src="${cdn("icons/picto_internet.svg")}"> 
            </td>
            <td>
              <span class="modal-content">
                You have <b>activated online payment</b>
              </span>
            <td>
          </tr>
          <tr>
            <td> 
              <img src="${cdn("icons/picto_3ds.svg")}"> 
            </td>
            <td>
              <span class="modal-content">
              You have <b>activated the 3DSecure</b> (two-factor authentification for online payment)
              </span>
            <td>
          </tr>
          <tr>
            <td> 
              <img src="${cdn("icons/picto_carte_valide.svg")}"> 
            </td>
            <td>
              <span class="modal-content">
              <b>Your card is valid</b> for payment
              </span>
            <td>
          </tr>
        <table>
        <div class="center" style="margin-top:20px"> 
          <b class="error">If necessary, please contact your bank for confirmation</b>
        </div>`,
  accountCreated: "Your account has been successfully created.",
  accountError: "Your account could not be created.",
  addARelative: "Add a relative",
  addCreditCard: "Add credit card",
  addPaimentMethod: "Add payment method",
  backToPaymentMethod: "Back to payment method",
  addPhoneNumber: "Add",
  addRelative: "Add relative",
  adminInformationWelcome:
    "L’équipe Medadom vous a transmis par mail, lors de votre inscription, votre identifiant ainsi que votre mot de passe. Merci de vous connecter ici avec ces identifiants. Contactez nous au 01 86 65 55 15 en cas de problème.",
  agreement: "Consentement",
  consentOfAssistance: "Consent of care assistant",
  agreementInvalid: "You have to accept the Terms and Conditions (CGUs).",
  alreadyAcount: "I already have a Medadom patient account.",
  anamneseAllergiesQuestionSubtitle: "(Pollen, drugs, ...)",
  anamneseAllergiesQuestion: "Do you have any allergies ?",
  anamneseAllergiesQuestion_relative_male:
    "Does your relative have any allergies ?",
  anamneseAllergiesQuestion_relative_female:
    "Does your relative have any allergies ?",
  anamneseAllergiesQuestionDetails: "Which allergy(ies) ?",
  anamneseDrugsQuestion: "Are you currenly on medication ?",
  anamneseDrugsQuestion_relative_male: "Is your relative on medication ?",
  anamneseDrugsQuestion_relative_female: "Is your relative on medication ?",
  anamneseIllnessQuestionSubtitle: "(Diabetes, hypertension, ...)",
  anamneseIllnessQuestion: "Do you have any chronic diseases?",
  anamneseIllnessQuestion_relative_male:
    "Has your relative ever had any chronic diseases ?",
  anamneseIllnessQuestion_relative_female:
    "Has your relative ever had any chronic diseases ?",
  anamneseIllnessQuestionDetails: "Which disease(s)?",
  anamneseOperationsQuestion: "Have you already been operated on ?",
  anamneseOperationsQuestion_relative_male:
    "Has your relative ever been operated on?",
  anamneseOperationsQuestion_relative_female:
    "Has your relative ever been operated on?",
  anamnesePregnantQuestion: "Are you pregnant or breast-feeding ?",
  anamnesePregnantQuestion_relative_female:
    "Is your relative pregnant or breast-feeding ?",
  antecedents: "Do you have a history of eye problems ?",
  apr: "April",
  askAgain: "Launch another request",
  ask_for_phone_re_enter: "Please enter the patient's phone number again.",
  ask_for_voiceCall: "Receive the code by voice call",
  aug: "August",
  averageConsultationTime: "Average consultation time",
  backToHome: "Back to home",
  birthdate: "Birthdate",
  birthdateModal: "Enter the birthdate of the account holder",
  birthdatePlaceholder: "DD / MM / YYYY",
  byPassEmail: "I do not have an email",
  byPassNir: "I do not have a social security number ",
  enterRelativeNir: "Enter the social security number of the relative.",
  byPassNir_relative: "The relative doesn't have a social security number",
  noBill: "You will not be billed.",
  doctorCancelCall:
    "We are sorry, the doctor has canceled the teleconsultation.",
  callCancelled: "Cancelled",
  callCannotBeCancelled: "We were unable to cancel the consultation",
  callExpired: "Expired",
  callHasBeenCancelled: "The consultation has been cancelled",
  callMeVerify: "Receive a call for the code",
  call_ophtalmologist: "Teleconsultation with the ophthalmologist",
  call_ortho: "Teleconsultation with the orthoptist",
  call_page: "teleconsultation",
  cancel: "Cancel",
  cancelAndDisconnect: "Cancel and disconnect",
  cancelCall: "Cancel consultation",
  cancelConsultation: "CANCEL CONSULTATION",
  continueConsultation: "Continue waiting",
  cancelTLC: "You are about to cancel the teleconsultation request",
  cancer: "Cancer",
  cannotLaunchTlc: "Unable to launch the consultation",
  cataract: "Cataract",
  cguAgreement:
    "I have read and accept <b>the terms and conditions</b>, as well as the processing of my personal health data for using the service",
  cguAndPrivacyTitle: "Terms and Personal Data",
  change_phone: "Change phone number",
  childLessThanSix: "children under 6 years old",
  choseYourCountry: "Please indicate the country",
  civility: "Civility",
  clickMeToVanish: "click me to vanish !",
  comeBackToLogin: "Come back to login",
  comeBackToSurvey: "Come back to survey",
  confirm: "Confirm",
  medicalcenter: "Medical center",
  chooseYourNationality: "Choose your nationality",
  confirmHangupCall: "Are you sure you want to hang up the teleconsultation ?",
  confirmCancelCall: "Are you sure you want to cancel the request ?",
  connectedAs: "Connected as ",
  consultationScheduledAt:
    "has confirmed the teleconsultation for this slot. There may be a delay, thank you for your patience.",
  contact_secretary: "Please contact the secretary \r\n to create your account",
  continue: "Continue",
  save: "Save",
  IUnderstandAndContinue: "I understand and continue",
  createCall: "Start the consultation",
  creating_call: "Request in progress",
  credit: "© 2021 MEDADOM All rights reserved",
  creditCard: "credit card",
  waintingForCardInsertion: "Waiting for card insertion",
  waitingForCardPayment: "Waiting for card payment...",
  presentYourCardOnTheTerminal: "Present your card on the terminal",
  paymentTimeout: "The payment has not been completed in the time allotted.",
  delayPassed: "Delay passed",
  paymentCancelled: "Contactless payment canceled",
  initializingPayment: "Initializing payment...",
  dateInvalid: "The date of birth is invalid",
  dec: "December",
  defaultErrorForm: "An error has occurred in the form.",
  defaultReplyWhichWho: "One of our doctors is available",
  deleteCard: "Delete Card",
  deleteRelative: "Delete the relative",
  deleteRelativeConfirmContent:
    "$RELATIVE_NAME$ will be <b>permanently deleted</b> from your list of relatives. Their <b>history</b> and <b>documents</b> will however be <b>kept</b>.",
  demo: "The demonstration of the machines",
  demo_page: "demonstration-outils",
  diabetes: "Diabetes",
  digestiveDisease: "Digestive disease",
  doYouHaveAnAccount: "Do you have a Medadom account ?",
  anamneseChoiceOfDoctor: "What would you like to do?",
  anamneseConsultNow: "Consult <b>now</b>",
  consultNow: "See a doctor now",
  now: "now",
  availability: "Availability",
  thisDoctorIsNotAvailable_html:
    "This doctor is unavailable, but a doctor from <b>CDS Mediksanté (Paris)</b> can <b>assist you immediately</b>",
  IConsultThisDoctor: "I want to consult with this doctor.",
  ifDoctorDoNotExist:
    "If the doctor you are looking for is not yet consulting on MEDADOM, you will be able to consult with another available doctor.",
  requestDoctorPlaceholder: "Enter the name of the doctor",
  addressNotProvided: "No address provided",
  searchDoctorInstruction: "Please enter your general practitioner's last name and/or first name to find them",
  searchMinLengthInstruction: "Type at least 2 characters to start the search",
  noDoctorsFound: "No doctors found. Please type the doctor's last name first then their full first name",
  treatingDoctor: "Your general practitioner",
  treatingDoctorResultsTitle: "Select your general practitioner",
  noTreatingDoctorSet: "You haven't added a general practitioner yet",
  anamneseChooseADoctor: "I have an appointment with a <b>specific doctor</b>",
  chooseADoctor: "I have an appointment with a specific doctor",
  anamneseChooseADoctor_relative_female:
    "My relative has an appointment with a <b>specific doctor</b>",
  anamneseChooseADoctor_relative_male:
    "My relative has an appointment with a specific doctor</b>",
  anamneseDoctorAvailableQuestion: "What is your situation?",
  nirIsExpiredTitle: "Your Carte Vitale is not up to date!",
  nirIsExpiredContent: `<span> This may affect the reimbursement of your teleconsultation,</span> <br /><b> update it with your pharmacist </b>`,
  anamneseDoctorAvailableQuestion_relative_male:
    "What is your relative's situation?",
  anamneseDoctorAvailableQuestion_relative_female:
    "What is your relative's situation?",
  doNotHaveDoctor: "<b>I do not have</b> a treating general practitioner",
  noLongerHaveDoctor: "I no longer have a treating general practitioner",
  noLongerHaveDoctor_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "She no longer has a treating general practitioner"
      : "He no longer has a treating general practitioner",
  removeFamilyDoctorText:
    "The treating general practitioner will be removed from your profile. You can add a new one at any time",
  removeFamilyDoctorText_relative: (gender: Gender) =>
    `Their treating general practitioner will be removed from their profile. ${gender === Gender.FEMALE ? "She" : "He"} can add a new one at any time`,
  removeFamilyDoctorAccept: "Remove and continue",
  removeFamilyDoctorError:
    "Unable to remove the treating general practitioner. Please try again.",
  doctorFarAway: "I am away from my treating general practitioner (holidays, etc.)",
  doctorNotAvailable:
    "My treating general practitioner <b>is not available</b>",
  doNotHaveDoctor_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "She <b>does not have</b> a treating general practitioner"
      : "He <b>does not have</b> a treating general practitioner",
  doctorNotAvailable_relative: (_gender: Gender) =>
    "My relative's treating general practitioner <b>is unavailable</b>",
  doctorFarAway_relative: (gender: Gender) =>
    gender === Gender.FEMALE
      ? "She <b>is away</b> from her treating general practitioner (holidays, etc.)"
      : "He <b>is away</b> from his treating general practitioner (holidays, etc.)",
  doctorNotInList: "My doctor isn't on the list",
  doctorAwaiting: "Your doctor is ready ! Your consultation will begin.",
  waitInFrontOfTheScreen: "Please wait in front of the screen...",
  documentAvailableInfo: "Find your medical documents in your Medadom space",
  inTab: ", in the tab ",
  deviceAreON: "The otoscope (A) and/or dermatoscope (D) are on.",
  documents: "Documents",
  drugAllergy: "other drugs allergy",
  foodAllergy: "Food allergy",
  penicillinAllergy: "Penicilline allergy",
  email: "email",
  notSuitableTLC: "Teleconsultation not suitable",
  IHaveRelativeConsent: "I have their consent",
  enterRelativeInformations: "Add a relative",
  enterYourBirthFirstname: "Please enter your birth first name",
  enterYourBirthLastname: "Please enter your birth last name",
  enterYourBirthLocation: "Please enter your place of birth",
  enterRelativeBirthFirstname: "Please enter $RELATIVE_NAME$'s birth first name",
  enterRelativeBirthLastname: "Please enter $RELATIVE_NAME$'s birth last name",
  enterRelativeBirthLocation: "Please enter $RELATIVE_NAME$'s place of birth",
  enter_lastname: "Please enter your last name",
  InputYourOldPassword: "Please enter your old password",
  InputYourPassword: "Confirm your password",
  enter_password: "Set a password, \n\r for creating your Medadom account",
  enter_phone: "Enter your phone number",
  notSuitableTLCContent:
    "Children under <b>3 years old</b> require a clinical examination.<br/>Teleconsultation is not suitable for this and is therefore <b>not possible</b> in this case.",
  IGotIt: "I understand",
  maxThreeReasonsTitle: "Please select a maximum of 3 reasons",
  errorCallState:
    "An error occurred during the call, \n\r Please contact our support",
  errorLogin: "There was an error in the form",
  errorOccuredWhenSendingCode: "An error occurred while sending the code",
  existingOrderError: "The teleconsultation already exists",
  expiredSession: "The session has expired. We will log you out",
  feb: "February",
  female: "Female",
  finalePageTitle: "Thank you for your visit!",
  firstConsultation: "First glasses consultation",
  firstname: "First name",
  first_birth_firstname: "First name",
  first_firstname: "First name",
  // Do not these two keys even though they contains empty string
  first: "",
  of_birth: "",
  // ----------------------------------
  forMe: "For me",
  forgottenPassword: "I forgot my password",
  gender: "Gender",
  honorificTitle: "Honorific title",
  glassesRenewal: "Glasses renewal",
  glaucoma: "Glaucoma",
  errorDate_shouldBeOlderThan: (minAge?: number) =>
    `You must be at least ${minAge || 3} years old.`,
  errorDate_shouldBeYoungerThan: (maxAge?: number) =>
    `Teleconsultation is not possible after ${maxAge || 110}`,
  invalideDate: "Incomplete or incorrect date of birth",
  DD: "DD",
  MM: "MM",
  YYYY: "YYYY",
  goBackToProfile: "Back to profile",
  helper: "MEDADOM team informs you :",
  doctorIsWritingYourDocs:
    "The doctor is currently drafting your medical documents....",
  stepCanTake: "This step usually takes",
  timeWaitingHungup: "5 to 10 minutes.",
  findDocumentsInYourProfile:
    "Find your medical documents anytime from your MEDADOM space.",
  followingInstructions_html: (deviceName?: string) =>
    `Place<br/><b>${
      deviceName ?? "the object"
    }</b><br/>according to the doctor's instructions`,
  putDown: (deviceName?: string) =>
    `Reposer <br/> <b>${deviceName ?? "l'objet"}</b>`,
  helperRegardingGenderRelative:
    "Double-check the gender of the person you are adding!",
  hangup: "Hang up",
  hangupTitleWarning: "Do you want to hang up?",
  hangup_subtitle: "Please wait a moment...",
  heartDisease: "Heart disease",
  hypertension: "Hypertension",
  IRefuseConsent: "Cancel",
  IAcceptConsent: "I accept",
  consentTitleModal: "Terms of Service",
  consentContentModal:
    "I have read and accept <a>the terms of service</a>, as well as the processing of my personal health data for using the service.",
  inProgress: "In progress...",
  inactivity: "You will be disconnected due to inactivity",
  incorrectInput: "Please enter a valid input for",
  infectiousDisease: "Infectious disease",
  inform_anamnesis: "The doctor needs some medical information about you",
  initial_step: "Your teleconsultation journey",
  inform_anamnesis_relative_male:
    "The doctor needs some medical information about the relative",
  inform_anamnesis_relative_female:
    "The doctor needs some medical information about the relative",
  inputYour: "Enter your ",
  enterThe: "Enter the ",
  cannotStartTLC: "Unable to start TLC",
  IhaveReadAndAccept: "I have read and accept ",
  theCGU: "the general terms and conditions of use ",
  andThe: "and the ",
  newsletterConsentCheckboxLabel:
    "I would like to receive Medadom's health tips and news.",
  privacyPolicies: "privacy policy ",
  ofMedadom: "of Medadom",
  cannotLoadTLC: " Unable to load tlc ",
  weHaveSendAnSms: "We've sent you an SMS!",
  cancelSignupQuestion_1: "Do you want to ",
  cancelSignupQuestion_bold1: "cancel your registration",
  cancelSignupQuestion_2: "or ",
  cancelSignupQuestion_bold2: "change your number",
  cancelSignupQuestion_3: "?",
  modifyMyNumber: "Change my number",
  cancelMySignup: "Cancel registration",
  cannotSendTheSms: "Impossible to resend the SMS",
  cannotStartReader: " cannot start the reader",
  cannotRetrievedProfessionalIdentity:
    " Unable to retrieve the identity of the healthcare professional",
  cannotRetrieveCompanions: " Unable to retrieve companions ",
  cannotCreateCompanion: " Unable to create companion: ",
  cannotDeleteCompanion: "Unable to delete companion",
  cannotGetCompanionsRelationship:
    "Impossible to retrieve companion relationships",
  cannotCancel: "Impossible to cancel",
  inputYourBirthCountry: "Enter your country of birth",
  inputYourBirthCity: "Enter your place of birth",
  inputYourRelativeBirthCity: "Enter the relative's place of birth",
  inputYourRelativeBirthCountry: "Enter the relative's country of birth",
  unknownBirthPlace: "Move to the next step",
  insertYourNir: "Insert your carte vitale",
  createPassword: "Please create a password",
  containsAtLeast: "Contains at least:",
  tenCharacters: "10 characters",
  oneLowerCaseLetter: "A lowercase letter",
  oneUpperCaseLetter: "An uppercase letter",
  oneNumber: "One digit",
  ineligibleReasonInformation:
    "For these reasons, you must visit your treating physician or consult a doctor in person.",
  invalidValidationCode: "An error occurred while validating the code.",
  invalid_password: "Invalid password",
  jan: "January",
  joinCallIn: "Join the call in",
  joinTheConsultation: "Join the consultation",
  jul: "July",
  jun: "June",
  keratoconus: "Keratoconus",
  kidneyDisease: "Kidney disease",
  lastname: "Preferred last name",
  birthLastname: "Last name",
  launch_tlc: "Start a teleconsultation",
  legalMentionArticleSix:
    "In accordance with Article 6 of the Public Health Code, you are free to choose your optician.",
  lensesRenewal: "Lens renewal",
  lessThan: "Less than",
  lessThanAYear: "Less than 1 year",
  locationError: "Please enter a valid location",
  locationInvalid: "Please select a valid place of birth",
  locationAddress: "Place of birth",
  locationAddressError: "Invalid place of birth",
  login: "Log in",
  loginNir: "Validate",
  loginTitle: "I already have a patient account",
  logoutTitle: "Do you want to log out?",
  logout: "Log out",
  logoutAdmin: "Pharmacy logout",
  male: "Male",
  mar: "March",
  may: "May",
  me: "me",
  medikSante: "MedikSanté",
  mismatchingErrorForm:
    "Credentials do not match : check username and password",
  mustContainLessThanHundredCharacters:
    "The field must contain less than 100 characters",
  cantContainSpaceAsFirstCharacters:
    "The first character cannot be a space or hyphen",
  cantContainTwoConsecutiveSpace:
    "The field cannot contain two consecutive spaces",
  cantContainTwoConsecutiveApostrophe:
    "The field cannot contain two consecutive apostrophes",
  cantContainTwoConsecutiveHyphen:
    "The field cannot contain two consecutive hyphens",
  cantContainHyphenFollowedByApostrophe:
    "The field cannot contain a hyphen followed by an apostrophe",
  cantContainHyphenFollowedBySpace:
    "The field cannot contain a hyphen followed by a space",
  cantFinishWithHyphenOrApostrophe:
    "The field cannot end with a hyphen or apostrophe",
  shouldStartWithAlphaOrApostrophe:
    "The field must start with a character or apostrophe",
  shouldContainAtLeastOneAlphaCharacter:
    "The field must contain at least one alphanumeric character",
  shouldNotContainSlash: "The field cannot contain a slash",
  modify: "Modify",
  ofTheRelative: "of the relative",
  modifyRelative: "Modify my relative",
  of: "of",
  label_input_the_male: "Enter the ",
  enter1erFirstname: "Enter your first name",
  call: "Call",
  Email: "Email",
  inputThe: (name: string) => {
    if (["birthdate"].includes(name)) return "Enter the " + en[name]
    else return "Enter the " + en[name]
  },
  modifyThe: (name: string) => {
    return "Modify the " + en[name]
  },
  modifyYour: (name: string) => {
    return "Modify your " + en[name]
  },

  addA: (name: string) => {
    return "Add a " + en[name]
  },
  modifyYourPassword: "Modify your password",
  addAFirstname: "Add a firstname",
  addALastname: "Add a lastname",
  nirWellKnown: "The social security number is well registered",
  exemptionEnded: "End of the government Covid-19 measure on full third-party payment. As of October 1, 2022, the patient will again have to pay the complementary part (reimbursed by the mutual insurance)",
  tlcExemptedDate: "As of October 1, 2022",
  tlcExemptedContent:
    "The regulatory coverage by Social Security will return to 70%, with a patient copayment of 30% (reimbursable by your mutual insurance). The current health context exempts advance payment for teleconsultation until 30/09/2022.",
  nextMeansYouAcceptCGU:
    "By continuing with the request, I confirm that I have read the Terms of Use",
  putHeadPhones: "If the terminal is equipped, put on the headphones",
  moreThanAYear: "More than 1 year",
  needHelp: "Need help?",
  next: "Next",
  skip: "Skip",
  conflictError: "Already existing",
  nexmoError: "This phone number cannot be validated. Please try with another number",
  nir: "Social security number",
  nirInvalid: "The social security number is not valid",
  nirLengthError: "The social security number must contain 15 digits",
  rppsLengthError: "The RPPS/Adeli must contain a maximum of 11 digits",
  nirManualInput: "Skip this step",
  nirReaderError: "We could not retrieve the information",
  codeSpacer: " ",
  codeAllowedChar: "9",
  nirMaskChar: "_",
  nirAllowedChar: "*",
  no: "NO",
  youWillBeInformedBySMS: "In case of advance, you will be notified by SMS",
  youWillBeInformedBySMSFifo:
    "You will be notified by SMS before your teleconsultation starts",
  noAppointment: "I do not have an appointment",
  noAppointment_relative_male: "My relative does not have an appointment",
  noAppointment_relative_female: "My relative does not have an appointment",
  noDocument: "The doctor has not issued any prescription",
  noEmailContentModal: `<div>
      <div class="center" style="margin-bottom:80px">
        <img  src="${cdn("icons/mail_picto.svg")}" alt="">
      </div>
      <table class="table-modal">
        <tr>
          <td></td>
          <td><b>By leaving your email address blank:</b></td></tr>
        <tr>
          <td><img height="100" src="${cdn("icons/supprimer.svg")}" alt=""></td>
          <td>You will not receive information on medical documents related to your consultation.</td>
        </tr>
        <tr>
          <td><img height="100" src="${cdn("icons/supprimer.svg")}" alt=""></td>
          <td>Our medical and administrative teams will not be able to contact you in case of need.</td>
        </tr>
      </table>
    </div>`,
  noEmailTitleModal: "Email address required",
  noNirTitleModal: "Warning",
  noNirContentModal: `<b>Without a social security number</b>, you will have to <b>pay the full amount</b> for the teleconsultation.`,
  noHistory: "No history",
  notAdapted: "Teleconsultation is not suitable for:",
  notBornInFrance: "I was not born in France?",
  bornInFrance: "I was born in France?",
  relativeBornInFrance: "The relative was born in France?",
  relativeNotBornInFrance: "The relative was not born in France?",
  french: "France",
  foreign: "Foreign",
  unknown: "Unknown",
  nov: "November",
  office: "Office",
  oct: "October",
  olderThanFifty: "Are you over 50 years old?",
  optional: "(optional)",
  orderForWhichDoctor: "Which doctor is your appointment with?",
  orderForWhichDoctor_relative_male:
    "Which doctor is your relative's appointment with?",
  orderForWhichDoctor_relative_female:
    "Which doctor is your relative's appointment with?",
  orderForWhichHour: "At what time is your appointment?",
  orderForWhichHour_relative_male:
    "At what time is your relative's appointment?",
  orderForWhichHour_relative_female:
    "At what time is your relative's appointment?",
  orderForWho: "Who is the consultation for?",
  otherAllergy: "Other",
  otherDisease: "Other",
  otherOphtalmologicDisease: "Other",
  page_admin: "admin",
  page_check_lastname: "validate-last-name",
  page_check_password: "validate-password",
  page_check_phone: "validate-phone",
  page_home: "home",
  page_insert_relative: "add-relative",
  page_lobby: "choose-connection",
  page_login: "login",
  page_nir: "carte-vitale",
  page_not_authorized: "401",
  page_not_found: "404",
  page_order: "questions",
  page_register: "register",
  page_register_personal_data: "enter-personal-data",
  page_reset_password: "reset-password",
  page_verify: "verify",
  page_verify_phone: "verify-mobile",
  page_welcome: "welcome",
  panel_for_secretary:
    "If you are the secretary, please enter the admin password",
  password: "Password",
  passwordMustBeEightLength: "The password must be at least 8 characters long",
  password_validation_char: "8 characters",
  password_validation_lower: "one lowercase letter",
  password_validation_number: "one number",
  password_validation_title: "Your password must contain at least:",
  password_validation_upper: "one uppercase letter",
  patientPutError: "We could not update your profile",
  patientPutNirError: "Your social security number is not valid",
  patientPutNirSuccess: "Your social security number is valid",
  payloadErrorForm: "There was an error in the request",
  peoplesOlderThanSixtyFive: "people over 65",
  phone: "Phone Number",
  phoneExistingErrorForm:
    "The phone number is already used for another account",
  phoneInvalid: "The phone is not valid",
  phoneNotFound: "The phone number does not exist in our database",
  playerStopped: "The reader has stopped.",
  pollenAllergy: "Pollen allergy",
  postCallTitle: "`Teleconsultation successfully completed`",
  post_call_page: "transition",
  previous: "Back",
  print: "Print",
  rePrint: "Reprint",
  rePrintTitle: "Reprint",
  rePrintContent:
    "You have already sent a print request. Are you sure you want to reprint the document?",
  beSureDocumentsArePrinted:
    "Make sure your documents have been printed or shared with the pharmacist before disconnecting",
  printDocument: "Print documents",
  printMyCheckup: "Print my check-up",
  profile_myHistory: "Documents",
  profile_myInformations: "Profile",
  personalInformationsSubtitle: "Personal information",
  profile_myPayments: "Payment methods",
  profile_mySettings: "Settings",
  importedDocuments: "Imported documents",
  noImportedDocuments: "No imported document",
  importedDocumentsError: "Your imported documents could not be retrieved",
  importedDocumentPreviewError: "This document could not be displayed",
  provideYourMail:
    "Please enter your email for any needed follow-up on your teleconsultation",
  questionForWho: "Who is the consultation for?",
  questionForWhoCheckup: "Who is the check-up for?",
  questionWhichTime: "At what time is your appointment?",
  questionWhichWho: "Which doctor is your appointment with?",
  question_step: "pre-consultation questions",
  reset: "Clear the field",
  re_enter_phone: "Re-enter my phone number",
  readerInitialize: "Initialization...",
  readerSocketGenericError:
    "An error occurred with the card reader,\r\n Please enter it manually",
  readerSocketReadError: "An error occurred while reading your card",
  readerStopped: "The reader has stopped",
  reading: "\tReading in progress...",
  reason: "What is the reason for your visit?",
  reconnectAfterQuestion:
    "You will be reconnected to your consultation after completing the pre-consultation questions",
  redirectAfterQuestion:
    "You will return to the last step (ophthalmologist appointment) after completing the pre-consultation questions",
  register: "Register",
  cancelling: "Cancelling...",
  pleaseWait: " Please wait...",
  connectionLostReconnecting:
    "Connection interrupted. Reconnecting, please wait...",
  doctorConnectionUnstable:
    "The doctor's connection is unstable. Please wait...",
  registerStep_complementary: "Credentials",
  registerStep_creation: "Account creation",
  registerStep_nir: "Carte vitale",
  registerStep_personal: "Personal information",
  registerStep_verification: "Phone",
  registerTitle: "I am registering",
  register_creation_inProgress: "Account creation in progress",
  register_validation_inProgress: "Account validation in progress...",
  relative: "relative",
  relativesAddedError: "Your relatives could not be added to your account",
  relativesAddedSuccess: "Your relatives have been successfully added",
  relativeUseAnother: (name) => `The relative uses another ${name}`,
  relativeUseAnotherFirstname: `The relative uses another Firstname`,
  relativeUseAnotherLastname: `The relative uses another Lastname`,
  relaunchPlayer: "Restart the reader",
  removeYourNir: "Please remove your card",
  resendCodeInfo: "By clicking the button, a new SMS will be sent to you",
  resend_code: "Resend the code via SMS",
  resetPasswordRequestIsMadeTitle: (transport: "sms" | "email") =>
    `If an account is associated with this phone number, an ${transport} has been sent to you`,
  ifMailIsMissing:
    "if there is no mail linked to this account, the reinit will be done by SMS",
  resetPasswordTitle: "Enter your phone number to reset your password",
  respiratoryDisease: "Respiratory disease",
  referrerIsAHealthProfessional:
    "If you are not at a pharmacy, the documents will be sent to the system's referrer",
  scheduledConsultation: "Scheduled teleconsultation",
  subscribePlaceholder: "Allow MEDADOM to send you communications via email",
  newsletterNoValidEmailMessage:
    "To manage your newsletter subscription, you must first add a valid email address to your profile.",
  newsletterAddEmailCta: "Add my email",
  newsletterUnsubscribeConfirmTitle: "Newsletter unsubscription",
  newsletterUnsubscribeConfirmText:
    "By unsubscribing from newsletters, you <b>will no longer receive</b> health information and news.",
  newsletterUnsubscribeConfirmAccept: "Unsubscribe",
  newsletterHealthInfo_html:
    "Receive <b>health information and news</b>.",
  newsletterSubscribeSuccess:
    "Your subscription to MEDADOM newsletters has been successfully processed.",
  newsletterUnsubscribeSuccess:
    "Your unsubscription from MEDADOM newsletters has been successfully processed.",
  newsletterUpdateError: "Unable to update your newsletter subscription",
  doctorBusy: "All our doctors are busy. We are sorry.",
  selectDayBirthdate: "Day",
  selectMonthBirthdate: "Month",
  selectYearBirthdate: "Year",
  sendCode: "Send code",
  sendDocumentsToTheReferrer: "Send to the pharmacist",
  sent: "Sent!",
  sep: "September",
  smsNotReceived: "I did not receive the SMS",
  step_page: "step",
  strabismus: "Strabismus",
  teleconsultationTraining: "Teleconsultation training",
  tlcMade: "Teleconsultations conducted",
  thanks: "Thank you",
  turnThemOff: "Please turn them off before continuing.",
  tlcOf: "Teleconsultation on",
  tleOf: "Teleexpertise on",
  thanksForYourAnswers:
    "Thank you for answering the questions. The provided data remains confidential.",
  thirtyMinutes: "30 min",
  tooltipResetPassword: "An SMS will be sent to you with the login information",
  tooManyCallsForACustomer: "You have already had a teleconsultation today",
  touch_screen: "Touch the screen to start",
  pinkOctoberCampaign: "Pink October. Together against breast cancer.",
  tryAgain: "Restart the reader",
  useCard: "Start the teleconsultation",
  useAnother: (name) => `I use another ${name} daily`,
  IuseAnotherFirstname: "I use another Firstname daily",
  preferedLastname: "preferred last name",
  preferedFirstname: "preferred first name",
  IuseAnotherLastname: "I use another Lastname daily",
  male1stBirthFirstnamePlaceholder: "Jean...",
  male1stFirstnamePlaceholder: "Pierre...",
  BirthLastnamePlaceholder: "Dupont...",
  LastnamePlaceholder: "Durant...",
  female1stBirthFirstnamePlaceholder: "Marie...",
  female1stFirstnamePlaceholder: "Nathalie...",
  unknownBirthLocation: "Unknown place of birth",
  validate: "Validate",
  HealthProfessional: "Health Care Professional",
  Referer: "Referrer",
  verifiedPhoneError: "The verification code is incorrect",
  companionIdentification: "Assistant identification",
  verifiedPhoneSuccess: "Your phone has been successfully verified",
  verifyCallSuccess: "An SMS has been resent to you.",
  verifyCallSendSuccess: "You will receive a call in a few seconds",
  verifyNir: "Verify the numbers before proceeding to the next step",
  waitingForNirReader: "Searching for the Carte Vitale reader...",
  answerIn: "Searching for availability may take up to ...",
  tlcExpectedIn: "Teleconsultation expected in: ",
  weAreLookingForDoctors:
    "We are currently looking for an available doctor, please wait.",
  weekly: "This week",
  monthly: "This month",
  yearly: "This year",
  total: "Total",
  daily: "Today",
  in: "In",
  welcome: "Welcome",
  wichOnes: "Which ones (multiple selection possible)?",
  writeNir: "Enter your numbers",
  writeVerifyCode: "Enter the code you received at ",
  sendItAgain: "Resend code",
  SignupSuccess: "You have successfully registered!",
  RefraichToUpdateInfo: "Please refresh to update the information",
  WrongCode: "The code seems to be wrong",
  wrongNirLength: "Please enter 15 digits",
  wrongWay: "It seems you did not arrive here by following the correct path",
  yes: "YES",
  youHaveCancelledCall: "You have cancelled the teleconsultation",
  youNeedToRemoveLensesBeforeConsultation:
    "The medical examination requires removing your contact lenses the day before the teleconsultation.",
  youWillLaunchATLC: "You are about to launch a teleconsultation request",
  yourDocuments: "Your Documents",
  yourPharmaAccount: "Your pharmacy account",
  yourWaitingTime: "Your estimated waiting time:",
  // tutorial
  take: "Take",
  itIsDone: "It's done!",
  finish: "Finish",
  iTurnOff: "I have turned off",
  turnOffDevice_html: (
    deviceName: string,
  ) => `<b>Slide the cursor to turn off ${deviceName}</b>
    <br />
    (OFF position)`,
  turnOnDevice_dermatoscope_html: `Slide <b>the cursor all the way</b> to turn on<br />
    (LED position)`,
  turnOnDevice_otoscope_html: `Slide <b>the cursor all the way</b> to turn on<br />
    (LED2 position)`,
  seemsDeviceNotOn: (deviceName: string) =>
    `It seems that ${deviceName} is not working or is not plugged in`,
  lightDevice_html: `Slide <b>the brightness knob to the maximum</b>`,
  focusDevice_html: `<b>Adjust the image sharpness</b> if needed <b>by moving the grey knob</b>`,
  isNotTurnOn: "is not plugged in",
  inUsing: "In use",
  useVideoDevice_html: (deviceNaming: string) => {
    if (deviceNaming === "otoscope")
      return `Place <b>your thumb on the grey knob</b> then <b>insert the tip</b> into the ear`
    if (deviceNaming === "dermatoscope")
      return "<b>Place the tip on the area to be shown</b>"
  },
  updateVerifyMessage: (type: "email" | "sms") => {
    if (type === "email") {
      return "An email has been sent!"
    }
    if (type === "sms") {
      return "A sms has been sent!"
    }
  },
  price: "Tarif",
  MoreDetails: " Read more...",
  CouldntSendTheCode: "The code could not be resent.",
  profilUpdated: "We have successfully modified your profile",
  passwordIdentical: "The two passwords are identical",
  impossibleToModify: "Impossible to modify your",
  RelativeHasBeenUpdated:
    "We have successfully modified your relative's information",
  RelativeModificationImpossible: "Impossible to modify the relative",
  RelativeHasBeenDeleted: "We have successfully deleted your relative",
  RelativeDeletionImpossible: "Impossible to delete the relative",
  SomethingWentWrong: "An error has occurred",
  WrongVerificationCode: "The verification code is incorrect",
  warning: "Warning",
  modalContent_changePatientInformation_html:
    "If you wish to teleconsult for <b>another person</b>, you<br/> must <b>add a relative</b> during your next teleconsultation process<br/> <b>and not modify the data</b>",
  modifyDatas: "Modify data",
  datas_and_consent_title: "Data and Consent",
  datas_and_consent_point_1:
    "I confirm my free decision for a teleconsultation",
  datas_and_consent_point_2:
    "I accept the collection of my necessary personal data:",
  datas_and_consent_point_2_checkbox_1:
    "for my care pathway (administrative, medical record management, billing, SMS)",
  datas_and_consent_point_2_checkbox_2:
    "for the establishment of anonymous statistics and product improvement in compliance with applicable regulations",
  datas_and_consent_point_3:
    "Medadom and its subcontractors protect your health data. For more information and potential conflicts of interest, see",
  datas_and_content_point_3_ref: "the privacy policy",
  IConfirmAndContinue: "I confirm and continue",
  verifyEmail:
    "To confirm the change, enter the code received by email at the following address",
  add: "Add",
  IConfirmmyConsentDataChoice:
    "I confirm my free decision for a teleconsultation and accept my personal data collection in this context.",
  IConfirmMyConsentDataChoiceExempte:
    "I confirm that I have read the T&Cs, my free decision for a teleconsultation, and accept my personal data collection.",
  verifyPhone:
    "To confirm the change, enter the code received at the following number",
  addCarer: "Add a carer",
  addingCarer: "Adding a carer",
  addProfessional: "Add a professional",
  proOrReferent: "A healthcare professional or referent",
  aRelative: "A relative",
  asCarer: "As s Carer",
  iConsentTo: "I consent to",
  keepInformationConfidential: "keep the information exchanged confidential",
  duringTLC: "during the teleconsultation",
  iCommit: "I commit",
  validateAndContinue: "I validate and continue",
  insertAdminEmail:
    "For security reasons, please ask the administrator of the teleconsultation device to enter their email",
  IsaPro: "Is it a healthcare professional?",
  isCarerInTheList: "Is the carer in the list?",
  chooseALanguage: "Choose a Language",
  exemplePro: "(pharmacist, nurse, ...)",
  whichRelativeIsCaringYou: "Which relative is assisting you?",
  whichProfessionalIsCaringYou: "Which professional is assisting you?",
  whichProfessionalIsCaringYou_relative:
    "Which professional is assisting your relative ?",
  whatIsRelationship: "What is the relationship of the carer ?",
  confirmRemoveCarer: "You are about to remove the following carer :",
  incorrectFieldAdminEmail: "The field is incorrect",
  forMoreSecurity: "For more security",
  insertFirstnameCarer: "Enter the carer's first name",
  insertLastnameCarer: "Enter the carer's last name",
  insertPhoneCarer: "Enter the carer's phone number",
  insertRpps: "Enter the RPPS of the assisting healthcare professional",
  addPro: "Would you like to add this professional ?",
  healthPro: "Healthcare professional",
  delete: "Delete",
  otherCarer: "Other carer",
  noCarer: "No carer",
  ImCaredForThisTlc_relative: (_gender: Gender) =>
    "My relative is not autonomous and is assisted for this consultation",
  ImCaredForThisTlc: (_gender: Gender) =>
    "I am not autonomous and I am assisted for this consultation",
  carerExplanationTitle_html:
    "<b>Who can accompany me</b> during a teleconsultation?",
  carerExplanationIntro_html:
    "You have <b>the right to be assisted</b> by a healthcare professional or by a relative to carry out a teleconsultation.",
  carerExplanationRelativeBody_html:
    "You can name <b>one of your relatives</b> as a trusted person. For example your spouse, a close relative, etc...",
  carerExplanationProfessionalBody_html:
    "You can also be accompanied by <b>a healthcare professional</b> who is part of your care pathway.",
  carerExplanationRole_html:
    "The carer <b>supports you</b>, <b>simplifies the doctor's questions</b> and <b>completes the information</b> to improve the exchange. They must <b>respect the confidentiality</b> of teleconsultations.",
  whoIsCaringYouForTheTLC: "Who is assisting you for this teleconsultation?",
  whoIsCaringYouForTheTLC_relative:
    "Who is assisting your relative for this teleconsultation?",
  whoIsCaringYou: "Who will be assisting you?",
  whoIsCaringYou_relative: "Who is assisting your relative ?",
  required: "Wrong value",
  passwordHasNotBeenChangedSince_html: (days: number) => {
    if (days <= 0)
      return `<div>Your password has <b>expired</b>, it's been more than ${Math.abs(days)} ${Math.abs(days) <= 1 ? "day" : "days"} since you last changed it. For greater <b>security</b>, please change it <b>now</b>.</div>`
    if (days === 1)
      return `<div> Your password <b>expires tomorrow.</b> For <b>security</b> reasons, we encourage you to renew it now.</div>`
    return `<div> Your password <b>expires in ${days} days.</b> For <b>security</b> reasons, we encourage you to renew it now.</div>`
  },
  later: "Later",
  modifyPassword: "Change my password",
  uneligibleTitle: "Teleconsultation is not available for those cases :",
  teleexpertiseIneligibleTitle: "Teleexpertise is not available for those cases :",
  lessthan3yearOld: "Children under 3",
  unaccompaniedMinors: "Unaccompanied underage",
  ExtendedSickLeave: "Extension of previous workleave or work accident",
  fitnessCertificate: "Certificate of suitability (sport, nursery)",
  PrescriptionOfPsychoactive:
    "Prescription of psychoactive dependence treatments",
  IhaveUnderstood: "Continue Request",
  photoOfBurn: "(photos of the burn, ...)",
  photoOfJoins: "(photos of the joints, ...)",
  photoOfLesion: "(photos of lesion, ...)",
  photoOfThroat: "(photos of the throat, ...)",
  photoOfTheEye: "(photos of the eye, ...)",
  photoOfSting: "(photos of the sting, ...)",
  PrescriptionToBeRenewed: "(prescription to be renewed, treatment, ...)",
  analysisResults: "(analysis results, ...)",
  mister: "M.",
  miss: "Ms",
  sendBackTheCode: "REQUEST A NEW CODE IN",
  scanTogetSupport:
    "To access the MEDADOM Help Center, please scan this QR Code:",
  youCanContactSupport: "You can also contact support:",
  mondayToSaturday: "from Monday to Saturday, 9 a.m. to 7:30 p.m.",
  atSupportNumber: "on 01 86 65 55 15",

  noDoctorOnline: "No online doctor",
  doctorsNearby: "Doctor(s) nearby",
  doctorsOnline: "Doctor(s) online",
  consultNowWithDoctorOrChoseHim:
    "Consult with the next available doctor or choose your doctor",
  consultNowWithDoctor: "Consult with the next available doctor",
  teleconsultNow: "Consult now",
  choseDoctorWithoutGuarantee:
    "Choose my doctor without guaranteed immediate availability",
  doctorGuaranteeWarning:
    "The immediate availability of the selected doctor is not guaranteed. To reduce your waiting time, we recommend expanding your request to all available doctors.",
  expandMyRequest: "Expand my request",
  teleconsultWithChosenDoctor: "Consult with the selected doctor",
  skipStep: "skip step",
  indicateTreatingDoctorModal: "Indicate your treating physician to ensure continuity of care.",
  enterMyDoctor: "Enter my doctor",
  addYourWeight: "add your weight",
  addYourHeight: "add your height",
  addYourTemperature: "add your temperature",
  kilogram: "kg",
  celsius: "° C",
  iTookMyTemperature: "I took my temperature",
  unableToProcessVideo: "Sorry we are not able to process the video",
  choosePasswordRenewMethod:
    "Choose a method to receive the link to reset your password",
  estimatedWaitingTime: "estimated waiting time : ",
  takeYourTemperature: "Take your temperature",
  addYourSystolicTension: "Add your systolic blood pressure ",
  addYourDiastolicTension: "Add your diastolic blood pressure",
  addYourHeartrate: "Add your heartrate",
  addYourSaturation: "Add your saturation",
  takeYourSaturation: "Take your oxygen's saturation ",
  searchADoctor: "search for a doctor",
  iTookMyTension: "I took my blood pressure",
  iTookMySaturation: "I took my saturation",
  noResultBeMorePrecise: "no results. Refine your search",
  toReduceWaitingTime:
    "to reduce your waiting time, we suggest you expand your demand",
  takeYourTension: "take your blood pressure",
  whichTensiometer:
    "Which type of blood pressure monitor is on the kiosk (tool C)?",
  armTensiometer: "Arm blood pressure monitor",
  wristTensiometer: "Wrist blood pressure monitor",
  addYourTension: "add your blood pressure",
  wrongSaturationValue: "wrong saturation value",
  wrongTemperatureValue: "wrong temperature value",
  correctYourVitalsValue: (vitalType) =>
    `correct your ${vitalType === "temperature" ? "temperature," : ""} ${vitalType === "spo2" ? "saturation," : ""} the value entered seems incorrect`,
  or: "or",
  byCard: "By Card",
  payByCard: "Pay by card",
  payByContactlessPayment: "Pay by contactless payment",
  choosePaymentMethod: "Choose your payment method",
  pay: "pay",
  payAndLaunchTLC: "pay and launch teleconsultation",
  estimatedTlcWaitingTime: "Estimated waiting time: ",
  putYourHeadsetAndSpeak:
    "Put on your headset and speak in the microphone, does the gauge move ?",
  testTheHardware: "Test the hardware",
  doYouSeeYourselfOnScreen: "Do you see yourself on the screen ?",
  yourCameraDoesNotWork: "your camera does not work",
  beReadyForConsultation: "be ready for your consultation",
  restartDiagnostic: "restart test",
  pharmacyPleaseDo: "Pharmacy, please do the following : ",
  youDetectedAnIssue: "You just signalled an issue",
  cameraDoesNotWork: "The camera does not seem to work",
  microDoesNotWork: "The microphone does not seem to work",
  pleaseContactTheReferent: "Please contact the referent",
  verifyAccessTo: (mediaDevice: "video" | "audio") =>
    `verify your access to ${mediaDevice === "audio" ? "microphone" : "camera"}`,
  restartDevice: (mediaDevice: "video" | "audio") =>
    `Plug, unplug ${mediaDevice === "audio" ? "the microphone" : "the camera"}`,
  demoVersion: "VERSION DE DÉMO",
  continueAnyway: "continue anyway",
  cameraAndMicDoesNotWork: "camera and/or microphone does not seem to work",
  personalize: "Personalize ...",
  toASet: "to a set of",
  obligatoryPurposes: "mandatory purposes",
  forMyParkour:
    "for my care pathway (management of my administrative/medical file, invoicing and sending text messages/emails)",
  secondaryPurposes: "secondary purposes",
  likeDoingStatistic:
    "such as the establishment of anonymous statistics or the improvement of customer service",
  statisticsEstablishment: "establishment of anonymous statistics",
  clientServiceImprovment: "improving customer service",
  platformServiceImprovement:
    "improvement of the services offered by the platform (AI statistic's models training...)",
  activityPromotion: "promotion of Synapse activities and patients information",
  partnersFollowing: "monitoring of partnerships",
  medadomAndPartners: "MEDADOM and its subcontractors protect your health data",
  forMoreInformation:
    "For further information and possible conflicts of interest, see the",
  privacyPolicy: "personal data protection policy",
  IConfirmMyConsent:
    "I confirm my free choice for teleconsultation and that it is not imposed on me by any particular context.",
  IConfirmDataConsent: "I agree to the collection of my personal data.",
  consultingDoctors: "consulting doctors",
  firstOnsiteAddress: "first practice address",
  contraceptionModalNotSuitable_html: `For this reason, teleconsultation <b>is not possible</b> in the following cases:`,
  contraceptionModalNotSuitableReason1_html: `<b>Initial</b> prescription of contraception`,
  contraceptionModalNotSuitableReason2: "Request for pregnancy terminaion",
  listOfHealthProfessionals: "List of MEDADOM health professionals",
  createPaymentError: "An error occured during payment creation",
  paymentRefused: "Payment refused",
  retryLater: "Please try again in a few moments.",
  ifErrorStillOccur: "If the problem persists, please contact the device administrator.",
  enterAdminEmail: "Enter the administrator's email",
  enterAdminPassword: "Enter the administrator's password",
  associateKioskForContactlessPayment: "Paired smartphones for contactless payment reception",
  associateKiosk: "Configure contactless payment",
  associateNewPhone: "pair a new smartphone",
  generatingQRCode: "Generating QR code...",
  associatePaymentTerminal: "QR code pairing",
  scanQRCodeWithContactlessPaymentApp: "Follow the instructions in the « Med’Pay Pro » app and scan the QR code to pair your smartphone.",
  timeRemaining: "Time remaining",
  qrCodeExpired: "QR code expired, please regenerate",
  qrCodeRefreshIn: "QR code refresh in",
  regenerateQRCode: "Regenerate QR code",
  deviceModels: "Device models",
  downloadMedadomPaymentTerminalApp: "QR code for downloading the « Med’Pay Pro » app",
  scanQRCodeToDownloadApp: "To activate contactless payment on your device, start by downloading the « Med’Pay Pro » app on your smartphone by scanning the QR code below, then follow the steps indicated in the app.",
  confirmDeleteDeviceModel: "Confirm deletion",
  confirmDeleteDeviceModelMessage: "Are you sure you want to delete the following terminal?",
  deleteDeviceModelWarning: "The pairing with the following smartphone will be removed :",
  iHaveDownloadedTheApp: "I downloaded the app",
  waitingContactlessPaymentInfo: "Pay by card on the team member's terminal.",
  waitingContactlessPaymentButton: "Waiting for payment",
  useAnotherPaymentMethodInfo: "Please try again or use another payment method.",
  ageNotInRange: "Your age does not fall within the specified age ranges.",
  forThisCourse: "for this course.",
  courseReservedFor: "This course is reserved for people whose age falls within one of the following brackets:",
  eighteenToTwentyFiveYears: "18 to 25 years old",
  fortyFiveToFifty: "45 to 50 years old",
  sixtyToSixtyFive: "60 to 65 years old",
  seventyToSeventyFive: "70 to 75 years old",
  thanksForYourInterest: "We thank you for your interest and invite you to change your route.",
  the: "The",
  prevention: "Checkup",
  pharmacist: "Pharmacist",
  pharmacistActionRequired: "Action required from the pharmacist",
  pharmacistEmailPrompt:
    "Please ask the pharmacist to enter the login email address of this kiosk (administrator email)",
  pharmacistEmailMismatch:
    "The email address entered does not match the administrator email of this kiosk.",
  preventionPharmacistConfirmTitle: "Interview with your pharmacist",
  preventionPharmacistConfirmYes: "Yes, a pharmacist is available",
  preventionPharmacistConfirmNo: "No, choose another route",
  preventionSurveyEndTitle: "Thank you for your responses!",
  preventionSurveyEndButton: "Finish the questionnaire",
  preventionDocumentGenerationTitle: "Thank you!",
  preventionDocumentGenerationText_html:
    "Your document is <b>being generated</b>...",
  preventionHandoffChoiceTitle: "Where would you like to answer the questionnaire?",
  preventionHandoffOnPhone: "On my phone",
  preventionHandoffOnKiosk: "On the kiosk",
  preventionHandoffQrTitle: "Complete the questionnaire",
  preventionHandoffQrSubtitle_html:
    "<b>Scan the QR code</b> to answer on your <b>phone.</b>",
  preventionHandoffPhoneTitle: "Continue on your phone",
  preventionHandoffPhoneText:
    "You can now log out of the kiosk and answer the questionnaire on your phone.",
  preventionHandoffLogout: "Log out",
  preventionHandoffContinueOnKiosk: "Continue on the kiosk",
  preventionHandoffContinueOnPhone: "Continue on my phone",
  preventionHandoffInterruptTitle: "The questionnaire started on your phone will be interrupted",
  preventionHandoffInterruptText: "The answers given on your phone will not be kept. Do you want to continue on the kiosk?",
  preventionHandoffLinkError: "The link cannot be generated right now, you can answer on the kiosk.",
  preventionTemplateError: "The questionnaire cannot be loaded right now. Please try again.",
  pharmacistEndTitle: "Your prevention assessment is complete",
  pharmacistEndPrintInfo_html:
    "You can <b>print your documents</b> with your pharmacist. Payment is made directly at the pharmacy.",
  finishAndSendDocuments: "Finish and send my documents",
  pharmacistEndSentTitle: "Documents sent",
  pharmacistEndSentMessage:
    "Your documents have been sent. You can print them with your pharmacist.",
  isAProgramOfMinistry: "is a program of the Ministry of Health and Prevention that invites you to",
  takeStockHealth: "take stock of your health",
  itIs: 'It is',
  hundredPourcentFree: "hundred pourcent free",
  withoutAdvance: "without advance payment.",
  changeGender: "Change gender",

  youreGonna: "you're gonna",
  fillAForm: "fill a form",
  aboutFortyQuestion: "about forty questions and",
  lessThanTenMinutes: "about 10 minutes is enough",
  toAnswer: "to answer it",

  youWillBenefit: "The interview will then take place with the pharmacist for a dedicated discussion. You will benefit from",
  healthAdvice: "personalized health advice.",

  objectiveOf: "The objective of the questionnaire",
  isSimple: "is simple :",

  getInitialAdvice: "Get initial advice on how to take action to improve your health",
  becomeAwareOf: "Become aware of your lifestyle habits",
  acknowledgeThings: "Familiarize yourself with the topics that may be addressed.",

  youCantDoPrevention: "You are not eligible for the prevention assesment",

  returnHomePage: "return homepage",
    // Dermatology
  chooseSpecialistCheckupDelay: "5-minute pathway",
  dermatologist: "Dermatology",
  teleexpertise: "Dermatology advice",
  pathwayLabelGeneralist: "General medicine pathway",
  pathwayLabelDermatology: "Dermatology pathway",
  pathwayLabelCheckup: "Health check-up pathway",
  pathwayLabelPrevention: "Prevention assessment pathway",
  dermatologyCheckupDelay: "Tele-expertise within 48 hours",
  dermatoIUnderstand: "I understand the pathway",
  dermatoRecapTitle: "Summary of your request",
  dermatoRecapSubtitle: "Please review your information before continuing",
  dermatoRecapReason: "Reason for consultation",
  dermatoRecapMotif: "Reason",
  dermatoRecapSubReason: "Sub-reason",
  dermatoRecapBodyZones: "Affected area(s)",
  dermatoRecapSymptoms: "Other symptom(s)",
  dermatoRecapChronicIllness: "Chronic illness(es)",
  dermatoRecapOperations: "Past operation(s)",
  dermatoRecapAllergies: "Known allergy(ies)",
  dermatoRecapMedications: "Regular medication intake",
  dermatoRecapDermHistory: "Dermatological history",
  dermatoRecapFamilyCancer: "Family history of skin cancer",
  dermatoRecapRecentTravel: "Recent travel (within 6 months)",
  dermatoRecapZoneEvolution: "Recent evolution of the affected area",
  dermatoRecapProblemDuration: "Skin problem duration",
  dermatoRecapZoneEvolutionDuration: "Significant evolution since",
  dermatoRecapLastControl: "Last dermatological consultation",
  dermatoRecapSunExposure: "Frequent sun exposure",
  dermatoRecapSunburnBefore20: "Sunburns before age 20",
  dermatoRecapPhototype: "Phototype",
  dermatoRecapPatientDetails: "Your notes",
  teleexpertiseConsentTitle: "Validation and consent",
  teleexpertiseConsentSubtitle:
    "The patient and pharmacist must validate the request before submission",
  teleexpertisePharmacistConsent:
    "I confirm, as the pharmacist, that I have verified the information and approve sending the request.",
  teleexpertiseInformationConsent:
    "I confirm, as a healthcare professional, that I have verified the information and validate the submission of the request.",
  teleexpertisePatientConsent:
    "I confirm that the patient has been informed about the tele-expertise request and consents to its submission.",
  teleexpertiseConsentSubmit: "Submit request",
  dermatoGeneralistTitle: "General practitioner",
  dermatoSpecialistTitle: "Dermatologist",
  dermatoSpecialistDescription: "The doctor may directly request <b>in writing</b> the opinion of a <b>dermatologist</b>, who will respond within <b>48 working hours</b> with their assessment.",
  dermatoPharmaTitle: "Return to the pharmacy",
  dermatoPharmaDescription: "You will be <b>notified by SMS and email</b> as soon as your dermatological opinion is available. You will simply need to <b>return to the pharmacy</b> to collect it directly on this device.",
  dermatoSelectedDocumentsTitle: "Use your smartphone to take a photo of the affected area",
  dermatoTakePhoto: "take a photo",
  dermatoVideoCaptureSkip: "Skip this step",
  dermatoVideoCaptureShooting: "Taking the photos...",
  dermatoVideoCaptureSelectBest:
    "Please select a <u> sharp, centred photo </u> that clearly shows the area concerned",
  dermatoVideoCaptureSelectRetake: "Retake",
  dermatoVideoCaptureSelectValidate: "Validate photo",
  dermatoVideoCapturePhotoName: "Dermatoscope photo",
  dermatoVideoCaptureTurnOffDevice: "Turn off the device to continue",
  dermatoVideoCaptureTutorialLabel: "Tutorial",
  dermatoVideoCaptureVideoFeedLabel: "Video feed",
  dermatoVideoCaptureTakeAndTurnOnDevice: "Take and turn on tool D (dermatoscope)",
  dermatoSymptomsTitle: "What other symptoms do you have?",
  dermatoSymptomFever: "Fever",
  dermatoSymptomSweat: "Sweating",
  dermatoSymptomPain: "Pain",
  noSymptoms: "No symptoms",
  otherSymptoms: "Other",
  dermatoBodyZoneTitle: "Where is the affected area located?",
  dermatoBodyZoneFront: "Front of the body",
  dermatoBodyZoneBack: "Back of the body",
  dermatoBodyZoneWholeBody: "Whole body",
  dermatoBodyZoneFace: "Face",
  dermatoBodyZoneHead: "Head",
  dermatoBodyZoneNeck: "Neck",
  dermatoBodyZoneHands: "Hand(s)",
  dermatoBodyZoneFeet: "Feet",
  dermatoBodyZoneChest: "Chest",
  dermatoBodyZoneBackBody: "Back",
  dermatoBodyZoneArms: "Arms",
  dermatoBodyZoneLegs: "Leg(s)",
  dermatoBodyZoneArmpits: "Armpits",
  dermatoBodyZoneGenitals: "Genital area",
  dermatoBodyZoneButtocks: "Buttocks",
  dermatoBodyZoneShoulders: "Shoulder(s)",
  dermatoBodyZoneOther: "Other",
  dermatoAnamnesisQuestionsTitle: "Are you concerned by any of the following?",
  dermatoHistory: "Dermatological history (e.g., )",
  dermatoHistory_relative_male:
    "Does your relative have any dermatological history?",
  dermatoHistory_relative_female:
    "Does your relative have any dermatological history?",
  dermatoHistoryDetailsTitle: "Which dermatological history?",
  dermatoHistorySkinCancer:
    "Skin cancer (melanoma, carcinoma) — personal or family",
  dermatoHistoryEczema: "Eczema (atopic dermatitis)",
  dermatoHistoryPsoriasis: "Psoriasis",
  dermatoHistoryAcne: "Acne",
  dermatoHistoryChronicHives: "Chronic hives",
  dermatoHistoryHerpesZona: "Recurrent herpes / shingles",
  dermatoHistoryRosacea: "Rosacea",
  dermatoFamilyCancer: "Family history of skin cancer",
  dermatoFamilyCancer_relative_male:
    "Does your relative have a family history of skin cancer?",
  dermatoFamilyCancer_relative_female:
    "Does your relative have a family history of skin cancer?",
  dermatoRecentTravel: "Recent travel (within 6 months)",
  dermatoRecentTravel_relative_male:
    "Has your relative recently traveled (within 6 months)?",
  dermatoRecentTravel_relative_female:
    "Has your relative recently traveled (within 6 months)?",
  dermatoZoneEvolution: "Has the affected area changed recently?",
  dermatoZoneEvolution_relative_male:
    "Has your relative's affected area changed recently?",
  dermatoZoneEvolution_relative_female:
    "Has your relative's affected area changed recently?",
  dermatoProblemDurationTitle: "Onset of your dermatological problem",
  dermatoProblemDuration: "How long have you had this skin problem?",
  dermatoZoneEvolutionDurationTitle: "Evolution of the area",
  dermatoZoneEvolutionDuration:
    "Since when have you observed a significant evolution of the area?",
  dermatoDurationLessThan48h: "Less than 48 hours",
  dermatoDuration2To7Days: "Between 2 and 7 days",
  dermatoDuration1WeekTo1Month: "1 week to 1 month",
  dermatoDuration1To6Months: "1 to 6 months",
  dermatoDurationMoreThan6Months: "More than 6 months",
  dermatoOverviewPart1_html: "A <b>tele-expertise request</b> will be sent to a <b>dermatologist</b>, who will provide an advice within <b>48 working hours</b>.",
  dermatoOverviewInfoTitle: "Your dermatology pathway",
  dermatoOverviewInfoItem1_html: "Access to <b>a detailed opinion</b> from a dermatologist",
  dermatoOverviewInfoItem2_html: "<b>No prescription will be issued</b>; if needed, you will have to teleconsult a doctor or see one in person",
  dermatoOverviewInfoItem3_html: "If your condition requires it, <b>an in-person appointment</b> may be recommended",
  dermatoOverviewPart2_html: "You will receive this dermatologist advice and be notified <b>by SMS and email</b>. You can pick it up <b>on site</b>, on the device, optionally accompanied by the pharmacist.",
  pharmacistMustBeHere: "A healthcare professional is present with you?",
  pharmacistMustBeHereSubtitle_html: "The assistance of a healthcare professional, such as a pharmacist <b>is mandatory</b> to <b>continue the pathway</b>.",
  pharmacistMustBeHereProfessionalPresent: "Yes, a professional is present",
  pharmacistMustBeHereBackToPathway: "No, return to pathway selection",
  pharmacistInfoTitle: "Pharmacist information",
  pharmacistRppsTitle: "Search your RPPS number",
  pharmacistRppsPlaceholder: "Enter your RPPS number",
  pharmacistRppsModify: "Modify",
  pharmacistFinessLabel: "Pharmacy billing FINESS",
  pharmacistFinessHeadingBold: "Billing FINESS",
  pharmacistFinessHeadingSuffix: "of the establishment",
  pharmacistFinessPlaceholder: "9 digits — different from the legal FINESS",
  pharmacistFinessLengthError: "The billing FINESS must contain exactly 9 digits",
  pharmacistRppsLengthError: "The RPPS must contain a maximum of 11 digits",
  pharmacistFinessFacturationLabel: "Enter the pharmacy's billing FINESS",
  pharmacyLabel:"pharmacy",
  pharmacistFinessInputPrefix:"Enter the billing FINESS of the",
  pharmacistFinessFacturationHint: "9 digits — different from the legal FINESS (EJ)",
  pharmacistInfoContinue: "Continue",
  pharmacistBillingError:
    "An error occurred while saving billing information.",
  pharmacistBillingSuccess: "Billing information saved",
  pharmacistEnterRppsPrefix: "Enter the RPPS number of the",
  pharmacistTitulaireLabel: "the pharmacy",
  dermatoSubReasonTitle: "Specify your reasons",
  dermatoPimpleAcne: "Acne",
  dermatoPimpleRecentlyAppeared: "Recently appeared pimples",
  dermatoPimplePersistentAndRecurrent: "Recurring and persistent pimples",
  dermatoPimplePainfulAndSwollen: "Painful and swollen pimples",
  dermatoPimpleWithPus: "Pimples with pus",
  dermatoPimpleSubcutaneousCysts: "Painful subcutaneous cysts",
  dermatoOtherUnusualHairLoss: "Unusual hair loss",
  dermatoOtherNailPeelingOrThickeningOrColoring: "Peeled, thickened or colored nail",
  dermatoOtherVerrucousOrGrowthOnSkin: "Wart or growth on the skin",
  dermatoOtherCicatriceChangedAppearance: "Scar that has changed appearance",
  dermatoOtherWhiteOrDepigmentedSpot: "White or depigmented spot",
  dermatoMolesSuspect: "Suspicious mole",
  dermatoMolesChangedShape: "Mole that has changed shape",
  dermatoMolesRecentlyIncreased: "Mole that has recently grown",
  dermatoMolesChangedColor: "Mole that has changed color",
  dermatoMolesBleedingOrOozing: "Mole that bleeds or oozes",
  dermatoDarkSpotAppearedRecently: "Dark spot that appeared recently",
  dermatoTreatmentLessEffective: "Treatment that has become less effective",
  dermatoTreatmentSkinReaction: "Skin reaction since the start of a treatment",
  dermatoTreatmentIrritatedOrDrySkin: "Irritated or dry skin since a treatment",
  dermatoTreatmentSymptomsReturned: "Symptoms returned after the end of treatment",
  dermatoTreatmentDoubt: "Doubt about the use of a treatment",
  dermatoItchingEczema: "Eczema",
  dermatoRashHerpes: "Herpes",
  waitingStaff: "Is a staff member present with you?",
  waitingStaffSubtitlePrefix: "You will need to present your contactless payment method on",
  waitingStaffSubtitleTerminal: "their terminal",
  waitingStaffSubtitleMandatory: "Their presence is required.",
  launchContactlessPayment: "YES, CONTINUE",
  start: "Start",
  checkupOverview: 
  "The <b>health check-up</b> allows you to easily evaluate your overall health by calculating your BMI and measuring your constants.<br/><br/> This service is strictly <b>CONFIDENTIAL</b>.",
  checkupHealth: "Health check-up",
  checkupEndedInformation_html:
  "Your check-up is <b>complete.</b> You can now <b>print your results</b> to keep them.",
  checkupMissingData: "Missing data, calculation impossible.",
  previousButton: "Previous",
  yourCheckupHealth: "Your health check-up",
  yourCheckupEnded: "Your health check-up is completed",
  chooseAPath: "Choose a pathway",
  checkupAdvices: {
    bmi: {
      labelUnder185: "Underweight",
      labelUnder25: "Normal",
      labelUnder30: "Overweight",
      labelOver30: "Obesity",
      adviceUnder185: "A medical opinion may help you stabilize your weight.",
      adviceUnder25: "Your BMI is in the normal range.",
      adviceUnder30: "A medical opinion may help you prevent associated risks.",
      adviceOver30: "A medical opinion is recommended.",
      advice: "Your BMI is in the normal range.",
      massLabel: "Body Mass Index",
    },
    heartRate: {
      labelLow: "Low",
      labelNormal: "Normal",
      labelHigh: "High",
      labelHypertension: "Hypertension",
      adviceLow: "Monitor the appearance of dizziness or fatigue.",
      adviceNormal: "Your results are in the recommended norms.",
      adviceHigh: "A medical opinion is recommended.",
      adviceHypertension: "A medical opinion is recommended.",
      generalAdvice: "Your results are to be monitored.",
      heartRateLabel: "Blood pressure",
    },
    oxygenSaturation: {
      labelUnder90: "Severe hypoxia",
      labelUnder95: "Moderate hypoxia",
      labelOver95: "Normal",
      adviceUnder90: "A medical opinion is recommended.",
      adviceUnder95: "Result outside the optimal zone. A surveillance is recommended.",
      adviceOver95: "Your results are in the recommended norms.",
      oxygenSaturationLabel: "Oxygen saturation",
    },
  },
  checkUpEndComment: "For any question about your constants, you can now launch a teleconsultation, or choose to disconnect.",
  technical_diagnostic: "technical diagnostic",
  diagnosticCompleted: "Technical diagnostic completed",
  completeDiagnostic: "Complete diagnostic",
  checkupDocumentError: "The check-up document could not be generated",
  checkupDocumentMissingData: "Missing data, the health check-up cannot be generated.",
  checkupDocumentSentError: "The check-up document could not be sent",
  checkupDocumentSentSuccess: "The check-up document has been sent successfully",
  microphoneAndCameraWorkCorrectly: "The microphone and camera seem to be working correctly.",
  nurse: "Nurse",
  sendReportToMT: "automatic retrieval of my primary care physician's details and forwarding of the medical report to them in the event of treatment away from my usual place of residence.",
  youWillAttendedInPriority: "you will be attended to as a priority",
  mediaProblemDetected:
    "<b>Sound or video</b> problem detected.<br />Check that your <b>camera</b> and/or <b>microphone</b> are properly connected.<br />If the problem persists, <b>click “Refresh”</b>.",
  mediaProblemBadge: "Sound or video problem",
  refreshPage: "Refresh",
  myAccount: "My account",
  deleteMyAccount: "Delete my account",
  accountDeletionContext: "Account deletion",
  accountDeletionWarningTitle: "You are about to request the deletion of your account",
  accountDeletionWarningText_html:
    "All your personal data and medical documents will be <b>permanently archived or deleted</b> in accordance with the applicable regulations, once the request has been processed by our technical teams.",
  accountDeletionEnterPassword: "Enter your password",
  accountDeletionWrongPassword: "The password is incorrect",
  accountDeletionCodeTitle: (transport: string) =>
    transport === "email"
      ? "Enter the code received by email"
      : transport === "voice"
        ? "Enter the code received by phone"
        : "Enter the code received by SMS",
  accountDeletionCodeSentTo: (transport: string, phone: string) =>
    transport === "email"
      ? "Code sent to your email address"
      : transport === "voice"
        ? `Call placed to <b>${phone}</b>`
        : `Code sent to <b>${phone}</b>`,
  accountDeletionDoneTitle: "Your request has been received",
  accountDeletionDoneText_html:
    "Our teams are processing your request. You will receive <b>a confirmation email</b> once the deletion is done.",
  finishAndLogout: "Finish and log out",
}

export default en
